import serviceADX from "@/helpers/py-service";

const state = {
  loading: false,
  meta: {},
  list: [],
  //
  detailMeta: {},
  detail: [],
};

const mutations = {
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_DETAIL(state, payload) {
    state.detail = payload;
  },
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_DETAIL_META(state, data) {
    if (data.meta) {
      state.detailMeta.page = data.meta.current_page;
      state.detailMeta.itemsPerPage = data.meta.per_page;
      state.detailMeta.lastPage = data.meta.last_page;
      state.detailMeta.totalItems = data.meta.total;
    }
  },
};

const actions = {
  list: (store, params) => {
    store.state.loading = true;
    return serviceADX
      .get("charging-station/charger-error-codes", params)
      .then((data) => {
        store.commit("SET_META", data.body);
        store.commit("SET_LIST", data.body.data);
        // const m = {
        //   current_page: 1,
        //   per_page: data.body.length,
        //   last_page: 1,
        //   total: data.body.length,
        // };
        // store.commit("SET_META", { meta: m });
        return data.body.data;
      })
      .finally(() => (store.state.loading = false));
  },
  setDetail: (store, params) => {
    store.state.loading = true;
    return serviceADX
      .get("charging-station/charger-error-count", params)
      .then((data) => {
        store.commit("SET_DETAIL", data.body);
        const m = {
          current_page: 1,
          per_page: data.body.length,
          last_page: 1,
          total: data.body.length,
        };
        store.commit("SET_DETAIL_META", { meta: m });
        return data.body.data;
      })
      .finally(() => (store.state.loading = false));
  },
  exportList: (store, params) => {
    store.state.loading = true;
    return serviceADX
      .get("charging-station/download-charger-error-codes", params)
      .then((data) => {
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
  setEmailAlerts: (store, params) => {
    store.state.loading = true;
    return serviceADX
      .post("charger-fault-alerts/fault-alert-rules", params)
      .then((data) => {
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
  getDetailMeta(state) {
    return state.detailMeta;
  },
  getDetail(state) {
    return state.detail;
  },
};

const csmsChargingdiagnostics = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default csmsChargingdiagnostics;
